// extracted by mini-css-extract-plugin
export var backToHomeButtonWrapper = "index-module--back-to-home-button-wrapper--GB9MX";
export var headingWrapper = "index-module--heading-wrapper--sEl+e";
export var main = "index-module--main--yLzUz";
export var paragraph = "index-module--paragraph--4rBqP";
export var paragraphWrapper = "index-module--paragraph-wrapper--0L6IR";